import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { SDGComponent, Result } from '../../_models/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as GlobalVariables from '../globals/globals';
import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { SaveDiscardDialogComponent } from '../save-discard-dialog/save-discard-dialog.component';

var COMP = environment.component.status;


interface ValWt {
  value?: any;
  wt: number;
  detail_value?: string;
  display_value?: string;
}

@Component({
  selector: 'app-status-quest',
  templateUrl: './status-quest.component.html',
  styleUrls: ['./status-quest.component.css']
})

export class StatusQuestComponent implements OnInit, OnDestroy {
  lang = 1;
  src_pdf: string;
  testmode = (environment.testmode || localStorage.getItem('editmode')=='1');
  admin_url = environment.url_django;
  is_partial : any = "false";
  loading = false;
  submit_attempted = false;
  grp : number = 0;
  last_saved: any;
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<any>;
  subscription1:Subscription;
  subscription2:Subscription;
  status_comp : any;
  answers: Object = {};
  questions: Object = {};
  values : Array<ValWt> = [];
  quesid_grp : Array<Array<Number>>=[[]];
  @ViewChild('f') f: any;
  guideText: string = '';
  guidePanelOpen: boolean = false;
  guideLinks: { url: string, label: string }[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService,
    public matdialog: MatDialog){}

    canDeactivate():Observable<boolean> {

      const questcomp = this;

      const obs = Observable.create(function(observer){
      var form_dirty = questcomp.f.dirty;
      if (form_dirty){
        const dialogRef = questcomp.matdialog.open(SaveDiscardDialogComponent, { width: '400px' });
        dialogRef.afterClosed().subscribe(result => {
         if(result=='save'){
          questcomp.is_partial='true';
          questcomp.submitForm(true);
          Object.keys(questcomp.f.controls).forEach(control => {
              questcomp.f.controls[control].markAsPristine();
          });
          $(".header_active").removeClass("header_active")
          $(".status-click").addClass("header_active")
          observer.next(false);
          observer.complete();
         }
         else if(result=='discard'){
          observer.next(true);
          observer.complete();
         }
       });
      }
      else{
          observer.next(true);
          observer.complete();
      }

      });
      return obs;
    }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".status-click").addClass("header_active")
    
    this.lang = GlobalVariables.findTranslationOptionsIndex(window);

    if (window.location.href.indexOf("/fr/") > -1) {
      this.src_pdf="./assets/SDG-PSS-guidelines-2019-FR.pdf";}
    else if (window.location.href.indexOf("/es/") > -1){
      this.src_pdf="./assets/SDG-PSS-guidelines-2019-V3.pdf";}
    else {
      this.src_pdf="./assets/SDG-PSS-guidelines-2019-V3.pdf";}

    this.results$ = this.resultService.getResultData(COMP);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
    this.subscription1 = this.sdgcomponent$.subscribe( data => {
      var categories = data.category;
      var ordered_categories = [];
      var cl = categories.length;

          //reordering categories based on order field in each categrory
          for(var i = 0; i< cl; i++){
            ordered_categories[categories[i].order-1] = categories[i];
          }

          //reordering sub_categories based on order field in each sub_categrory
          for(var i = 0; i< cl; i++){
            var oc_sc = ordered_categories[i].sub_category;
            var oc_osc = [];
            for(var j = 0; j< oc_sc.length; j++){
              oc_osc[oc_sc[j].order-1] = oc_sc[j];
            }
            ordered_categories[i].sub_category = oc_osc;
          }

          for(var i = 0; i< cl; i++){
            var oc_sc = ordered_categories[i].sub_category;
            for(var j = 0; j< oc_sc.length; j++){
              var qc = oc_sc[j].question_category;
              var oqc = [],oqc1 = [];
              for(var k = 0; k < qc.length; k++){
                oqc[qc[k].order-1] = qc[k];
              }
              var oqci=0;
              while(!oqc[oqci]) oqci++;
              for (var m=0; m < (oqc.length-oqci); m++)
                oqc1[m] = oqc[m+oqci];
              ordered_categories[i].sub_category[j].question_category = oqc1;
            }
          }

          for(var i = 0; i< cl; i++){
            var oc_sc = ordered_categories[i].sub_category;
            for(var j = 0; j< oc_sc.length; j++){
              var qc = oc_sc[j].question_category;
              for(var k = 0; k < qc.length; k++){
                var q = qc[k].question;
                var oq = [], oq1=[];
                for(var l = 0; l < q.length; l++){
                  var qn = q[l];
                  var idx = qn.question_grp * 3 + qn.order -1;
                  oq[idx] = q[l];
                }
                var oqi=0;
                while(!oq[oqi]) oqi++;
                for (var m=0; m < (oq.length-oqi); m++)
                  oq1[m] = oq[m+oqi];
                ordered_categories[i].sub_category[j].question_category[k].question = oq1;
              }
            }
          }
          data.category = ordered_categories;

        this.status_comp = data;

        for(var i = 0; i< this.status_comp.category.length; i++){
          for(var j = 0; j< this.status_comp.category[i].sub_category.length; j++){
            for(var k = 0; k< this.status_comp.category[i].sub_category[j].question_category.length; k++){
              var qc = this.status_comp.category[i].sub_category[j].question_category[k]
              var ql = qc.question.length;
              for(var l = 0; l< ql; l++){

                var question_cat = this.status_comp.category[i].sub_category[j].question_category[k];
                var question = question_cat.question[l];
                if (!question) continue;
//                  this.status_comp.category[i].sub_category[j].question_category[k].question[l];
                var qcat_qtype = question_cat.question_type;
                var question_id = question.id;
//                console.log(question.id);
//                console.log(question.required);
                var q_qgroup = question.question_grp;
                var question_text = question.question_text;
                var grp = false;
                var default_value = question_cat.default_value;

                //initialize questions into groups
                if(!this.quesid_grp[q_qgroup]){
                    this.quesid_grp[q_qgroup]=[];
                    grp=true;
                }

                this.status_comp.category[i].sub_category[j].question_category[k].question[l].grp=grp;

                var pattern = /.*/;//anything
                var is_pattern = true;
                var pattern_error = '';
                if(question.non_zero && question.percentage){
                    pattern = /^[0]?[.][0-9]*[1-9]+[0-9]*$|^[1-9][0-9]?([.][0-9]+)*$|^100$/;//non zero percentage
                    pattern_error = 'Percent >0'
                    }
                else if(question.non_zero){
                    pattern = /^[0]?[.][0-9]*[1-9]+[0-9]*$|^[1-9][0-9]*([.][0-9]+)*$/;//non zero number
                    pattern_error = 'Number >0'
                    }
                else if(question.percentage){
                    pattern = /^[1-9][0-9]?([.][0-9]+)*$|^100$|^[0]?([.][0-9]+)*$/;//percentage 0-100
                    pattern_error = 'Percent 0-100'
                    }
                else
                    is_pattern = false;

                var value=question.default_value;
                if (!value) value = '';
//                if(this.testmode){
//                  if(question.question_type_name=="Baseline")
//                    if(question.percentage)
//                      value=getRndInteger(1,20);
//                    else
//                      value=getRndInteger(1,2);
//
//                  if(question.question_type_name=="Current")
//                    if(question.percentage)
//                      value=getRndInteger(21,40);
//                    else
//                      value=getRndInteger(3,5);
//
//                  if(question.question_type_name=="Aspiration")
//                    if(question.percentage)
//                      value=getRndInteger(41,100);
//                    else
//                      value=getRndInteger(6,10);
//                }

                question.pattern=pattern;
                question.is_pattern=is_pattern;
                question.pattern_error=pattern_error;
                this.questions[question_id] = question;
                this.quesid_grp[q_qgroup].push(question_id);
                this.values[question_id]= {'value':value, 'wt':1, 'detail_value':'', 'display_value':''};
              }
            }
          }
        }
        this.subscription2 = this.results$.subscribe( data1 => {
//            if (data1[0].is_partial){
              for(var idx=0;idx<data1.length;idx++){
                var res = data1[idx];
                if (!this.last_saved){
                  this.last_saved = new Date(res.last_saved);
                }
                this.values[res.question] = <ValWt>{'value':res.value, 'wt':1, 'detail_value':'', 'display_value':''};
              }
//            }
         },
         error => {
           this.alertService.error(error);
        });
        },
        error => {
          this.alertService.error(error);
        });
  }

  option_translation(option_text, lang){
    if (lang == 1 || option_text == null)
      return option_text;
    let option_key = option_text.trim().toLowerCase();
    if (option_key in GlobalVariables.option_translations[lang])
      return GlobalVariables.option_translations[lang][option_key];
    return option_text;
  }

  empty_objects(objects_arrays){
    for (var j=0; j<objects_arrays.length; j++){
      var props = Object.getOwnPropertyNames(objects_arrays[j]);
      for (var i = 0; i < props.length; i++) {
        delete objects_arrays[j][props[i]];
      }
    }
  }

  empty_array_of_arrays(arr_of_arr){
    for (var j=0; j<arr_of_arr.length; j++){
    arr_of_arr[j] = null;
    }
    arr_of_arr = null;
  }

  ngOnDestroy() {
    this.empty_objects([this.status_comp,this.answers,this.questions]);
    this.empty_array_of_arrays(this.quesid_grp);
    this.values = null;

    if(this.subscription1)
      this.subscription1.unsubscribe();
    if(this.subscription2)
      this.subscription2.unsubscribe();
    }

  submitForm(valid){
    let user;
    if (localStorage.getItem('currentUserId')) {
        user = localStorage.getItem('currentUserId');
        user = JSON.parse(user);
        if(!user.can_edit){
          this.alertService.error("Sorry you are not authorized to save/submit. Please contact your country focal point for the rights");
          window.scroll(0,0);
          return;
        }
    }
    if(this.is_partial=="false")
      this.submit_attempted = true;
    if(!valid && this.is_partial=="false") {
      this.alertService.error("Please fill all required fields to submit the form. Or use save option for incomplete form");
      window.scroll(0,0);
      return;
    }
    this.loading = true;

      for(var i = 0; i< this.values.length; i++){
        if (typeof(this.values[i]) != "undefined"){
          this.answers[i]={
            question: i,
            value: this.values[i].value,
            value_weight: this.values[i].wt,
            display_value: this.values[i].display_value
          };
        }
      }
      this.resultService.create(this.answers, COMP, this.is_partial).subscribe(data => {
          this.loading = false;
          if (this.is_partial == "false")
            this.alertService.success("Form Submitted Successfully");
          else
            this.alertService.success("Form Saved Successfully");

          this.last_saved = new Date();
          window.scroll(0,0);
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
    }

  openGuide(text: string) {
    if (this.guidePanelOpen && this.guideText === (text || '')) {
      this.guidePanelOpen = false;
    } else {
      this.guideText = text || '';
      this.guidePanelOpen = true;
      const div = document.createElement('div');
      div.innerHTML = text || '';
      const anchors = div.querySelectorAll('a');
      this.guideLinks = Array.from(anchors).map(a => ({ url: a.href, label: a.textContent || a.href }));
    }
  }

  closeGuide() {
    this.guidePanelOpen = false;
  }

    resourcesBtnClick(){
        this.router.navigateByUrl('/sdg/status');
    }
    quesBtnClick(){
      this.router.navigateByUrl('/sdg/status-quest')
    }
    dataBtnClick(){
      this.router.navigateByUrl('/sdg/status-data')
    }
    reportBtnClick(){
      this.router.navigateByUrl('/sdg/status-report')
    }
}

function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
}



// WEBPACK FOOTER //
// ./src/app/sdg/status-quest/status-quest.component.ts